<template>
    <div class="box help column is-6">
        <h3 class="title is-3">Hjälptext för rummet</h3>
        <div class="room-help" v-if="data">
            <div class="field">
              <wysiwyg v-model="data.content" />
            </div>
            <div class="field">
                <label class="label">Ljudfil</label>
                <div v-if="data.media">
                    <audio controls>
                        <source :src="data.media" type="audio/mpeg">
                    </audio>
                    <a class="button" @click="removeMedia"><i class="fa fa-remove"></i></a>
                </div>
                <input v-else type="file" @change="updatemedia" placeholder="Ljud" accept=".mp3">
            </div>
            <div class="field">
                <button class="button is-default pull-right" @click="save"><i class="fa fa-save"></i>&nbsp; Spara hjälptext</button>
            </div>

        </div>
    </div>

</template>
<style>
  .editr{
    background-color: #fff;
    color: #000;
  }
</style>
<script>
// const _ = require('lodash')
import RoomData from '@/mixins/RoomContent'

export default {
  name: 'RoomHelp',
  mixins: [RoomData],
  data () {
    return {
      data: null,
      mediabutton: null,
      startdata: {
        content: null,
        media: null,
        group: 'help',
        age_group_id: null,
        key: 'help',
        type: 'string'
      }
    }
  },
  props: ['orgdata'],
  components: {},
  computed: {
  },
  methods: {
  },
  mounted () {
    this.reset()
  }
}
</script>
